import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { t } from 'ttag'
import YumButton from '../YumButton/YumButton'
import dayjs from '../../dayjsConfig'
import { isRtl } from '../../i18nInit'
import YumSmallSelect from '../YumSmallSelect/YumSmallSelect'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    lineHeight: '23px',
    margin: 0,
    justifyContent: 'center',
    '@media (min-width: 992px)': {
      justifyContent: 'flex-end',
    },
  },
}))

export enum ProgressPeriod {
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  //YEAR = 'YEAR',
}

export interface IProgressPeriodProps {
  progressPeriod: ProgressPeriod
  setProgressPeriodDates(progressPeriod: ProgressPeriod, progressPeriodDates: any): any
}

const options = [
  { key: ProgressPeriod.WEEK, text: t`Weekly` },
  { key: ProgressPeriod.MONTH, text: t`Monthly` },
  //{ key: ProgressPeriod.YEAR, text: t`Yearly` },
]

const getUnit = (progressPeriod: ProgressPeriod) => {
  const units = {
    [ProgressPeriod.WEEK]: 'isoWeek',
    [ProgressPeriod.MONTH]: 'month',
    //[ProgressPeriod.YEAR]: 'year',
  }
  return units[progressPeriod] as dayjs.OpUnitType
}

export default function YumProgressPeriod(props: IProgressPeriodProps) {
  const { progressPeriod } = props
  const classes = useStyles()
  const anchorRef = React.useRef<HTMLButtonElement>(null)
  const [open, setOpen] = React.useState(false)
  //const [isDrawerOpen, setIsDrawerOpen] = React.useState(false)
  const [startDate, setStartDate] = React.useState(new Date())
  const [endDate, setEndDate] = React.useState(new Date())

  // Legacy componentDidMount hook equivalent.
  React.useEffect(() => {
    setProgressPeriodDates(progressPeriod)
  }, [])

  const setProgressPeriodDates = (progressPeriod: ProgressPeriod) => {
    const unit = getUnit(progressPeriod)

    const startDate = dayjs()
      .utc()
      .startOf(unit as any)
      .toDate()
    const endDate = dayjs()
      .utc()
      .endOf(unit as any)
      .endOf('day')
      .toDate()

    // Set to state.
    //setProgressPeriod(progressPeriod)
    setStartDate(startDate)
    setEndDate(endDate)

    // Trigger AJAX call.
    props.setProgressPeriodDates(progressPeriod, { startDate, endDate })
  }

  const setPrevTimePeriod = () => {
    const unit = getUnit(progressPeriod)
    const units = unit === 'isoWeek' ? 'week' : 'month'

    // Prev week.
    const prevStartDate = dayjs(startDate)
      .utc()
      .subtract(1, units)
      .startOf(unit as dayjs.OpUnitType)
      .toDate()
    const prevEndDate = dayjs(endDate).utc().subtract(1, units).endOf(unit).toDate()

    setStartDate(prevStartDate)
    setEndDate(prevEndDate)

    // Trigger AJAX call.
    props.setProgressPeriodDates(progressPeriod, { startDate: prevStartDate, endDate: prevEndDate })
  }

  const setNextTimePeriod = () => {
    const unit = getUnit(progressPeriod)
    const units = unit === 'isoWeek' ? 'week' : 'month'

    // Prev week.
    const prevStartDate = dayjs(startDate).utc().add(1, units).startOf(unit).toDate()
    const prevEndDate = dayjs(endDate).utc().add(1, units).endOf(unit).toDate()

    setStartDate(prevStartDate)
    setEndDate(prevEndDate)

    // Trigger AJAX call.
    props.setProgressPeriodDates(progressPeriod, { startDate: prevStartDate, endDate: prevEndDate })
  }

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen)
  }

  const handleClose = (event: React.MouseEvent<EventTarget>) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return
    }

    setOpen(false)
  }

  const handleListKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Tab') {
      event.preventDefault()
      setOpen(false)
    }
  }

  const handleMenuItemClick = (event: React.MouseEvent<HTMLElement>, selected: ProgressPeriod) => {
    //setSelected(selected)
    //props.setProgressPeriod(selected, { startDate, endDate })
    setProgressPeriodDates(selected)

    /*if (selected === ProgressPeriod.CUSTOM) {
      setIsDrawerOpen(true)
    }*/

    //setAnchorEl(null)
    handleClose(event)
  }

  // return focus to the button when we transitioned from !open -> open
  /*const prevOpen = React.useRef(open)
  React.useEffect(() => {
    if (prevOpen.current && !open) {
      anchorRef.current!.focus()
    }

    prevOpen.current = open
  }, [open])*/

  /*const toggleDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event &&
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return
    }

    //this.setState({ isDrawerOpen: open })
    setIsDrawerOpen(true)
  }

  const setCustomPeriod = () => () => {
    setIsDrawerOpen(false)
  }*/

  const progressPeriodObj = options.find((o) => o.key === progressPeriod)
  const progressPeriodText = progressPeriodObj ? progressPeriodObj.text : '-'

  // @ts-ignore
  //const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent)

  const handlePeriodChange = (event: React.ChangeEvent<any>) => {
    const { value } = event.target as { value: ProgressPeriod }
    setProgressPeriodDates(value)
  }

  return (
    <div className={classes.root}>
      {isRtl ? (
        <>
          <YumButton
            onClick={setPrevTimePeriod}
            size="small"
            style={{
              marginLeft: '5px',
              marginRight: '15px',
              paddingLeft: '10px',
              paddingRight: '10px',
            }}
            disabled={startDate <= dayjs.utc('2021-01-01T00:00:00.000Z').toDate()}
          >
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 2L8 6L4 10" stroke="white" />
            </svg>
          </YumButton>

          <YumButton
            onClick={setNextTimePeriod}
            size="small"
            style={{
              marginLeft: '15px',
              marginRight: '0',
              paddingLeft: '10px',
              paddingRight: '10px',
            }}
            disabled={endDate > new Date()}
          >
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 2L4 6L8 10" stroke="white" />
            </svg>
          </YumButton>
        </>
      ) : (
        <>
          <YumButton
            onClick={setPrevTimePeriod}
            size="small"
            style={{
              marginLeft: '15px',
              marginRight: '5px',
              paddingLeft: '10px',
              paddingRight: '10px',
            }}
            disabled={startDate <= dayjs.utc('2021-01-01T00:00:00.000Z').toDate()}
          >
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 2L4 6L8 10" stroke="white" />
            </svg>
          </YumButton>

          <YumButton
            onClick={setNextTimePeriod}
            size="small"
            style={{
              marginLeft: '0',
              marginRight: '15px',
              paddingLeft: '10px',
              paddingRight: '10px',
            }}
            disabled={endDate > new Date()}
          >
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 2L8 6L4 10" stroke="white" />
            </svg>
          </YumButton>
        </>
      )}

      <YumSmallSelect variant="outlined" value={progressPeriod} onChange={handlePeriodChange}>
        {options.map((option, index) => (
          <option key={option.key} value={option.key}>
            {option.text}
          </option>
        ))}
      </YumSmallSelect>

      {/*<div style={{ position: 'relative', zIndex: 999 }}>
        <Button
          className={'btn-progress-period'}
          style={{
            display: 'inline-block',
            margin: 0,
            padding: '0 12px',
            lineHeight: '26px',
            fontSize: 10,
            fontWeight: 'bold',
            width: 'auto',
            minWidth: currentLang === Lang.ET ? 76 : currentLang === Lang.RU ? 87 : 93,
          }}
          ref={anchorRef}
          aria-controls={open ? 'menu-list-grow' : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
          variant="contained"
          color="primary"
          disableElevation
          disableRipple
        >
          {progressPeriodText}
          <svg
            style={{ marginLeft: 3, marginTop: -3 }}
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M10 4L6 8L2 4" stroke="white" />
          </svg>
        </Button>
        <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    autoFocusItem={open}
                    id="menu-list-grow"
                    onKeyDown={handleListKeyDown}
                    style={{
                      marginTop: 5,
                      padding: 0,
                      boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                      borderRadius: 5,
                    }}
                  >
                    {options.map((option, index) => (
                      <MenuItem
                        key={option.key}
                        selected={option.key === progressPeriod}
                        onClick={(event) => handleMenuItemClick(event, option.key)}
                        style={{ justifyContent: 'space-between' }}
                      >
                        {option.text}
                        {option.key === progressPeriod ? (
                          <svg
                            style={{ marginLeft: 10 }}
                            width="4"
                            height="4"
                            viewBox="0 0 4 4"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle cx="2" cy="2" r="2" fill="#006FFF" />
                          </svg>
                        ) : (
                          ''
                        )}
                      </MenuItem>
                    ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>*/}

      {/*<SwipeableDrawer
        anchor="bottom"
        open={isDrawerOpen}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
        disableBackdropTransition={!iOS}
        disableDiscovery={iOS}
        PaperProps={{
          style: {
            maxWidth: 375,
          },
        }}
      >
        <Typography variant="subtitle2" style={{ margin: '0 0 16px 0' }}>{t`Custom period`}</Typography>

        <Box
          style={{
            display: 'flex',
            flexWrap: 'nowrap',
            marginBottom: 14,
          }}
        >
          <Box style={{ flex: 1 }}>
            <TextField
              id="date"
              type="date"
              value={startDate}
              InputLabelProps={{
                shrink: true,
              }}
              style={{
                width: '163px',
                //width: '100%',
              }}
              variant="outlined"
              margin="normal"
            />
          </Box>
          <Box style={{ flex: 1, width: '19px', flexShrink: 0, lineHeight: '48px', textAlign: 'center' }}>-</Box>
          <Box style={{ flex: 1 }}>
            <TextField
              id="date"
              type="date"
              value={endDate}
              InputLabelProps={{
                shrink: true,
              }}
              style={{
                width: '163px',
                //width: '100%',
              }}
              variant="outlined"
              margin="normal"
            />
          </Box>
        </Box>
        <YumButton onClick={setCustomPeriod()}>{t`Update`}</YumButton>
      </SwipeableDrawer>*/}
    </div>
  )
}
